import TickIcon from "@/assets/colorable/tick.svg?react";
import clsxm from "@/lib/clsxm";
import {type FC, useId} from "react";

const CheckBox: FC<{
  isChecked?: boolean;
  onChange?: (newValue: boolean) => void;
  disabled?: boolean;
  className?: string;
  tickIconClassName?: string;
  label?: string;
  labelClassName?: string;
}> = ({isChecked = false, onChange, disabled = false, className, tickIconClassName, label, labelClassName}) => {
  const id = useId();

  return (
    <div className="flex items-center gap-2">
      <div className="relative flex size-5 shrink-0 items-center justify-center">
        <input
          id={label ? id : undefined}
          type="checkbox"
          checked={isChecked}
          disabled={disabled}
          onChange={() => onChange?.(!isChecked)}
          className={clsxm(
            "border-primary-light-solid size-5 appearance-none rounded-sm border shadow-xs transition-all duration-150",
            isChecked ? "bg-primary-dark-solid" : "bg-white",
            disabled
              ? `border-neutral-grey-light cursor-not-allowed ${
                  isChecked ? "bg-neutral-grey-dark" : "bg-neutral-grey-lightest"
                }`
              : "cursor-pointer",
            className,
          )}
        />
        {isChecked && (
          <TickIcon className={clsxm("pointer-events-none absolute size-2.5 shrink-0 text-white", tickIconClassName)} />
        )}
      </div>
      {label && (
        <label
          htmlFor={id}
          className={clsxm(
            "text-neutral-black mb-0 text-xs font-semibold",
            disabled ? "cursor-not-allowed" : "cursor-pointer",
            labelClassName,
          )}>
          {label}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
